import { CurrentUserFacade } from '@awread/core/users';
import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { map, tap } from 'rxjs/operators';
import { format, formatRelative, startOfDay, subDays } from 'date-fns';
import vi from 'date-fns/locale/vi';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { enUS } from 'date-fns/locale';
@Injectable({ providedIn: 'root' })
export class DepositsApi {
  constructor(
    private apollo: Apollo,
    private currentUserFacade: CurrentUserFacade,
    private httpClient: HttpClient,
  ) { }

  sendNotiDepositMail(email: string = 'hiepxanh@gmail.com') {
    const url = `/v1/api/notifications/noti-deposit?email=${email}`;
    return this.httpClient.get(`${url}`);
  }

  getAllDeposits() {
    return this.apollo
      .query<any>({
        query: gql`
          query allDeposits {
            deposits(orderBy: TIMESTAMP_DESC, filter: { payment: { distinctFrom: "system" } }) {
              nodes {
                depositId
                depositNid
                nodeId
                payment
                status
                timestamp
                type
                userId
                user {
                  username
                  userNid
                }
                value
              }
            }
          }
        `,
        fetchPolicy: 'network-only',
      })
      .pipe(
        map((res) => res?.['data']?.['deposits']?.['nodes']),
        map((res) => res.map((item: any) => ({ ...item, timeRelative: format(new Date(item.timestamp), 'Pp', { locale: vi }) }))),
      );
  }

  getAllDepositsByUserId() {
    return this.apollo
      .query<any>({
        query: gql`
          query getAllDepositsByUserId($userId: UUID!) {
            deposits(orderBy: TIMESTAMP_DESC, condition: { userId: $userId }) {
              nodes {
                depositId
                depositNid
                nodeId
                payment
                status
                timestamp
                type
                userId
                value
                memo
                balance
              }
            }
          }
        `,
        variables: {
          userId: this.currentUserFacade.getUserId(),
        },
        fetchPolicy: 'network-only',
      })
      .pipe(
        map((res) => res?.['data']?.['deposits']?.['nodes']),
        map((res) =>
          res.map((item: any) => ({
            ...item,
            timeRelative: format(new Date(item.timestamp), 'Pp', { locale: vi }),
            coin: Math.floor(Number(item.value)).toLocaleString('it-IT'),
          })),
        ),
      );
  }

  getDepositPendingByUserId() {
    return this.apollo
      .query<any>({
        query: gql`
          query getDepositPendingByUserId($userId: UUID!, $status: String = "pending") {
            deposits(condition: { userId: $userId, status: $status }) {
              nodes {
                depositId
                depositNid
                nodeId
                payment
                status
                timestamp
                type
                userId
                value
              }
            }
          }
        `,
        variables: {
          userId: this.currentUserFacade.getUserId(),
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((res) => res?.['data']?.['deposits']?.['nodes']));
  }

  getUserWallet(userId: any) {
    return this.apollo
      .query<any>({
        query: gql`
          query getUserWallet($userId: UUID!) {
            wallet(userId: $userId) {
              balance
              nodeId
              userId
            }
          }
        `,
        variables: {
          userId,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((res) => res?.['data']?.['wallet']));
  }

}
